import React, { useEffect } from 'react';


const useMediaDevices = () => {
    const [deviceId, setDeviceId] = React.useState<string>('');
    const [devices, setDevices] = React.useState<MediaDeviceInfo[]>([]);

    useEffect(
        () => {
            navigator.mediaDevices.enumerateDevices()
                .then(devices => setDevices(
                    devices.filter(({kind, deviceId}) => kind === 'videoinput' && deviceId)
                ));
        },
        []);

    return {
        devices,
        deviceId,
        setDeviceId,
    }
};

export default useMediaDevices;
